import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { X } from 'lucide-react';
import { cn } from '../../lib/cn.js';
import styles from './Chip.module.css';
/** Interactive filter / removable / provenance chip (CLAUDE_DESIGN.md §6.4). */
export function Chip({ children, icon, active = false, disabled = false, onClick, onRemove, removeLabel, className, }) {
    const content = (_jsxs(_Fragment, { children: [icon, _jsx("span", { children: children }), onRemove && removeLabel && (_jsx("button", { type: "button", className: styles['remove'], disabled: disabled, onClick: (event) => {
                    event.stopPropagation();
                    onRemove();
                }, "aria-label": removeLabel, children: _jsx(X, { size: 11, "aria-hidden": "true" }) }))] }));
    if (onClick) {
        return (_jsx("button", { type: "button", onClick: onClick, disabled: disabled, "aria-pressed": active, className: cn(styles['chip'], styles['interactive'], active && styles['active'], className), children: content }));
    }
    return _jsx("span", { className: cn(styles['chip'], active && styles['active'], className), children: content });
}
